import { render, staticRenderFns } from "./AdminUsers.vue?vue&type=template&id=2a7641b5&scoped=true&"
import script from "./AdminUsers.vue?vue&type=script&lang=js&"
export * from "./AdminUsers.vue?vue&type=script&lang=js&"
import style0 from "./AdminUsers.vue?vue&type=style&index=0&id=2a7641b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7641b5",
  null
  
)

export default component.exports